"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventType = void 0;
var EventType;
(function (EventType) {
    EventType["BID_ACCEPTED"] = "bid-accepted";
    EventType["BID_RECEIVED"] = "bid-received";
    EventType["ITEM_SOLD"] = "item-sold";
    EventType["RENTAL_ENDED"] = "land-rental-ended";
    EventType["RENTAL_STARTED"] = "land-rental-started";
    EventType["ROYALTIES_EARNED"] = "royalties-earned";
})(EventType = exports.EventType || (exports.EventType = {}));
//# sourceMappingURL=base.js.map